export default "__VITE_ASSET__sjC4xUgq__"